import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import v from 'scss/v';

const ErrorInput = styled.input`
  border-color: ${v('$primary-alizarin')};
  box-shadow: 0 0 6px ${v('$grayscale-gainesboro')};
`;

const InputContainer = props =>
  (props.hasError ? <ErrorInput {...props} /> : <input {...props} />);

InputContainer.propTypes = {
  hasError: PropTypes.bool,
};

InputContainer.defaultProps = {
  hasError: false,
};

export default InputContainer;
